import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import outLayout from "@/views/Layout";
// 创建路由实例
const router = new VueRouter({
    routes: [
        {
            path: "/404",
            component: () => import("@/views/404"),
            hidden: true,
        },
        {
            path: "/",
            component: outLayout,
            redirect: "/home",
            children: [
                {
                    path: "home",
                    name: "Home",
                    component: () => import("../views/home/index"),
                    meta: { title: "首页", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "photovoltaic",
                    name: "Photovoltaic",
                    component: () => import("../views/home/photovoltaic/index"),
                    meta: { title: "光伏储能", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "energyManagement",
                    name: "energyManagement",
                    component: () =>
                        import("../views/home/energyManagement/index"),
                    meta: { title: "企业能管", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "buyAndSellElectricity",
                    name: "buyAndSellElectricity",
                    component: () =>
                        import("../views/home/buyAndSellElectricity/index"),
                    meta: { title: "购售电", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "operationsAndMaintenance",
                    name: "operationsAndMaintenance",
                    component: () =>
                        import("../views/home/operationsAndMaintenance/index"),
                    meta: { title: "电力运维", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "news",
                    name: "EnterpriseNews",
                    component: () => import("../views/home/news/index"),
                    meta: { title: "新闻动态", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "news/newsDetails",
                    name: "EnterpriseNewsDetails",
                    component: () => import("../views/home/news/details"),
                    meta: {
                        title: "动态详情",
                        icon: "dashboard",
                        activeMenu: "/news",
                    },
                    hidden: true,
                },
                {
                    path: "product",
                    name: "ProductCenter",
                    component: () => import("../views/home/product/index"),
                    meta: { title: "产品中心", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "solution",
                    name: "Solution",
                    component: () => import("../views/home/solution/index"),
                    meta: { title: "解决方案", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "serve",
                    name: "Serve",
                    component: () => import("../views/home/serve/index"),
                    meta: { title: "服务与支持", icon: "dashboard" },
                    hidden: true,
                },
                {
                    path: "aboutUs",
                    name: "Serve",
                    component: () => import("../views/home/aboutUs/index"),
                    meta: { title: "关于我们", icon: "dashboard" },
                    hidden: true,
                },
            ],
        },
    ],
});

export default router;
